import { css } from '@emotion/react';
import { SettingsSection } from '@frontend/settings-ui';
import { ComponentProps } from '@frontend/types';
import { useScheduleSettingsSmallMode } from '../../hooks/settings/use-schedule-settings-small-mode';
import { EmotionStyle } from '../../types';

type Props = ComponentProps<typeof SettingsSection> & {
  transparentInSmallMode?: boolean;
  smallModeCss?: EmotionStyle;
};

export const ScheduleSettingsSection = ({ transparentInSmallMode = false, smallModeCss, ...props }: Props) => {
  const { isSmallMode } = useScheduleSettingsSmallMode();
  return (
    <SettingsSection
      {...props}
      css={[styles.settingSection(isSmallMode, transparentInSmallMode), isSmallMode && smallModeCss]}
    />
  );
};

const styles = {
  settingSection: (isSmallMode = false, transparentInSmallMode = false) => [
    css`
      container-type: inline-size;
      container-name: schedule-settings-section;
    `,
    isSmallMode &&
      transparentInSmallMode &&
      css`
        padding: 0;
        background: none;
        box-shadow: none;
      `,
    isSmallMode &&
      css`
        [role='tabpanel'] {
          > div,
          > section {
            padding-left: 0;
            padding-right: 0;
          }
        }
      `,
  ],
};
